(function(){
  var ITEMS_KEY = 'crystals_wishlist';
  var BOARDS_KEY = 'crystals_wishlist_boards';
  var EMAIL_KEY = 'crystals_wishlist_email';
  var DEFAULT_BOARDS = [{ id: 'all', name: 'All Crystals', icon: 'heart', system: true }];

  var SYNC_URL = 'https://cfo-one-delta.vercel.app/api/wishlist';
  var _pushTimer = null;
  function syncCreds() {
    if (window.__crystalsCustomerId && window.__crystalsWishlistToken) {
      return { id: window.__crystalsCustomerId, token: window.__crystalsWishlistToken };
    }
    return null;
  }
  function schedulePush() {
    var c = syncCreds();
    if (!c) return;
    clearTimeout(_pushTimer);
    _pushTimer = setTimeout(function () {
      fetch(SYNC_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: c.id, token: c.token, items: getItems(), boards: getBoards() })
      }).catch(function(){});
    }, 2000);
  }
  function mergeFromServer() {
    var c = syncCreds();
    if (!c) return;
    fetch(SYNC_URL + '?customer_id=' + encodeURIComponent(c.id) + '&token=' + encodeURIComponent(c.token))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (remote) {
        if (!remote) return;
        var localItems = getItems();
        var localBoards = getBoards();
        var byId = {};
        (remote.items || []).concat(localItems).forEach(function (i) {
          var k = String(i.id);
          if (!byId[k] || (i.added && i.added < byId[k].added)) byId[k] = i;
        });
        var mergedItems = Object.keys(byId).map(function (k) { return byId[k]; });
        var boardIds = {};
        var mergedBoards = [];
        (remote.boards || []).concat(localBoards).forEach(function (b) {
          if (b && b.id && !boardIds[b.id]) { boardIds[b.id] = 1; mergedBoards.push(b); }
        });
        if (!boardIds.all) mergedBoards.unshift(DEFAULT_BOARDS[0]);
        save(ITEMS_KEY, mergedItems);
        save(BOARDS_KEY, mergedBoards);
        updateHeartStates();
        try { document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { action: 'sync' } })); } catch(e) {}
        if (mergedItems.length !== (remote.items || []).length || mergedBoards.length !== (remote.boards || []).length) {
          schedulePush();
        }
      })
      .catch(function(){});
  }

  function load(key, fallback) {
    try { var d = localStorage.getItem(key); return d ? JSON.parse(d) : fallback; }
    catch(e) { return fallback; }
  }
  function save(key, data) {
    try { localStorage.setItem(key, JSON.stringify(data)); } catch(e) {}
  }

  function getItems() { return load(ITEMS_KEY, []); }
  function getBoards() { return load(BOARDS_KEY, DEFAULT_BOARDS); }

  function getEmail() {
    return window.__crystalsCustomerEmail || localStorage.getItem(EMAIL_KEY) || '';
  }
  function saveEmail(email) {
    try { localStorage.setItem(EMAIL_KEY, email); } catch(e) {}
  }
  function isValidEmail(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  }

  function showEmailModal(onSuccess) {
    var existing = document.getElementById('wl-email-overlay');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.id = 'wl-email-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);backdrop-filter:blur(4px);z-index:100001;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .25s;';
    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;border-radius:12px;padding:32px;width:90%;max-width:380px;box-shadow:0 20px 60px rgba(0,0,0,.15);transform:translateY(20px);transition:transform .25s;text-align:center;';
    modal.innerHTML =
      '<svg viewBox="0 0 24 24" style="width:32px;height:32px;stroke:#c04040;stroke-width:1.5;fill:none;margin:0 auto 16px;display:block;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '<h3 style="font-family:Ogg Roman,Cormorant Garamond,Georgia,serif;font-size:22px;font-weight:400;margin:0 0 8px;color:#1C1915;">Save Your Wishlist</h3>' +
      '<p style="font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:13px;color:#777;margin:0 0 20px;line-height:1.5;">Enter your email to save favorites across devices and get notified about price drops.</p>' +
      '<input id="wl-email-input" type="email" placeholder="your@email.com" style="width:100%;padding:13px 16px;border:1px solid #ddd;border-radius:8px;font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:14px;outline:none;box-sizing:border-box;transition:border-color .2s;" />' +
      '<p id="wl-email-error" style="font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:12px;color:#c04040;margin:6px 0 0;display:none;">Please enter a valid email address.</p>' +
      '<button id="wl-email-submit" style="width:100%;margin-top:16px;padding:14px;background:#1C1915;color:#fff;border:none;border-radius:8px;font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;transition:background .2s;">Save to Wishlist</button>' +
      '<button id="wl-email-cancel" style="width:100%;margin-top:8px;padding:10px;background:transparent;color:#999;border:none;font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:12px;cursor:pointer;">Cancel</button>' +
      '<p style="font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:10px;color:#bbb;margin:16px 0 0;line-height:1.4;">We\'ll only email you about items on your wishlist. Unsubscribe anytime.</p>';
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    requestAnimationFrame(function() {
      overlay.style.opacity = '1';
      modal.style.transform = 'translateY(0)';
    });
    var input = document.getElementById('wl-email-input');
    var error = document.getElementById('wl-email-error');
    setTimeout(function() { input.focus(); }, 100);
    input.addEventListener('focus', function() { input.style.borderColor = '#1C1915'; });
    input.addEventListener('blur', function() { input.style.borderColor = '#ddd'; });
    function close() {
      overlay.style.opacity = '0';
      modal.style.transform = 'translateY(20px)';
      setTimeout(function() { overlay.remove(); }, 250);
    }
    function submit() {
      var email = input.value.trim();
      if (!isValidEmail(email)) {
        error.style.display = 'block';
        input.style.borderColor = '#c04040';
        return;
      }
      saveEmail(email);
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TneciN', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Wishlist',
                profile: { data: { type: 'profile', attributes: { email: email } } },
                email: { marketing: { consent: 'SUBSCRIBED' } }
              }
            }
          })
        }).catch(function(){});
      } catch(e) {}
      close();
      onSuccess(email);
    }
    document.getElementById('wl-email-submit').addEventListener('click', submit);
    input.addEventListener('keydown', function(e) { if (e.key === 'Enter') submit(); });
    document.getElementById('wl-email-cancel').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  }

  function trackWishlistEvent(product, email) {
    if (!email) return;
    try {
      var klProps = {
        'ProductName': product.title || '', 'ProductID': product.id,
        'Handle': product.handle || '', 'ImageURL': product.image || '',
        'URL': 'https://www.crystals.com' + (product.url || '/products/' + (product.handle || '')),
        'Price': parseFloat(product.price) || 0
      };
      var klBody = {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Added to Wishlist' } } },
            properties: klProps,
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };
      fetch('https://a.klaviyo.com/client/events/?company_id=TneciN', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(klBody)
      }).catch(function(){});
    } catch(e) {}
  }

  function addItem(product, email) {
    var items = getItems();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(product.id)) return;
    }
    items.push({
      id: product.id, handle: product.handle || '', title: product.title || '',
      url: product.url || '/products/' + (product.handle || ''),
      image: product.image || '', price: product.price || '0',
      compare_at_price: product.compare_at_price || '',
      variant_id: product.variant_id || '', board: product.board || 'all', added: Date.now()
    });
    save(ITEMS_KEY, items);
    updateHeartStates();
    trackWishlistEvent(product, email || getEmail());
    try { document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { action: 'add', product: product } })); } catch(de) {}
    schedulePush();
  }

  function removeItem(id) {
    var items = getItems().filter(function(i) { return String(i.id) !== String(id); });
    save(ITEMS_KEY, items);
    updateHeartStates();
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { action: 'remove', id: id } }));
    schedulePush();
  }

  function hasItem(id) {
    var items = getItems();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) return true;
    }
    return false;
  }

  function addBoard(name, icon) {
    var boards = getBoards();
    var id = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '');
    for (var i = 0; i < boards.length; i++) { if (boards[i].id === id) return boards[i]; }
    var board = { id: id, name: name, icon: icon || 'folder', system: false };
    boards.push(board);
    save(BOARDS_KEY, boards);
    schedulePush();
    return board;
  }

  function removeBoard(id) {
    var boards = getBoards().filter(function(b) { return b.id !== id || b.system; });
    save(BOARDS_KEY, boards);
    var items = getItems().map(function(i) { if (i.board === id) i.board = 'all'; return i; });
    save(ITEMS_KEY, items);
    schedulePush();
  }

  function moveItem(productId, boardId) {
    var items = getItems().map(function(i) {
      if (String(i.id) === String(productId)) i.board = boardId;
      return i;
    });
    save(ITEMS_KEY, items);
    schedulePush();
  }

  function updateHeartStates() {
    var btns = document.querySelectorAll('.wishlist-heart, [data-wishlist-btn]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var pid = btn.getAttribute('data-wishlist-product-id');
      if (!pid) continue;
      var svg = btn.querySelector('svg');
      if (hasItem(pid)) {
        btn.classList.add('is-wishlisted');
        if (svg) { svg.style.fill = '#c04040'; svg.style.stroke = '#c04040'; }
      } else {
        btn.classList.remove('is-wishlisted');
        if (svg) { svg.style.fill = 'none'; svg.style.stroke = '#555'; }
      }
    }
  }

  function showToast(msg, isRemove) {
    var existing = document.getElementById('wl-toast');
    if (existing) existing.remove();
    var t = document.createElement('a');
    t.id = 'wl-toast';
    t.href = '/pages/wishlist';
    t.innerHTML = '<svg viewBox="0 0 24 24" style="width:16px;height:16px;stroke:' + (isRemove ? '#999' : '#c04040') + ';stroke-width:2;fill:' + (isRemove ? 'none' : '#c04040') + ';flex-shrink:0;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> <span>' + msg + '</span> <span style="opacity:.5;font-size:11px;margin-left:4px;">View Wishlist &rarr;</span>';
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);z-index:999999;background:#1C1915;color:#fff;padding:12px 24px;border-radius:8px;font-family:Basis Grotesque,Helvetica Neue,sans-serif;font-size:13px;font-weight:600;display:flex;align-items:center;gap:8px;opacity:0;transition:all .3s ease;box-shadow:0 8px 32px rgba(0,0,0,.15);cursor:pointer;text-decoration:none;';
    document.body.appendChild(t);
    requestAnimationFrame(function() { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
    setTimeout(function() { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(20px)'; setTimeout(function() { t.remove(); }, 300); }, 3500);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.wishlist-heart, [data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var pid = btn.getAttribute('data-wishlist-product-id');
    if (!pid) return;
    var title = btn.getAttribute('data-wishlist-title') || 'Item';
    if (hasItem(pid)) {
      removeItem(pid);
      showToast(title + ' removed from wishlist', true);
      return;
    }
    var product = {
      id: pid, handle: btn.getAttribute('data-wishlist-handle') || '',
      title: title,
      url: btn.getAttribute('data-wishlist-url') || '',
      image: btn.getAttribute('data-wishlist-image') || '',
      price: btn.getAttribute('data-wishlist-price') || '0',
      compare_at_price: btn.getAttribute('data-wishlist-compare-price') || '',
      variant_id: btn.getAttribute('data-wishlist-variant-id') || ''
    };
    var email = getEmail();
    if (email) {
      addItem(product, email);
      showToast(title + ' saved to wishlist', false);
    } else {
      showEmailModal(function(capturedEmail) {
        addItem(product, capturedEmail);
        showToast(title + ' saved to wishlist', false);
      });
    }
  }, true);

  function init() { updateHeartStates(); mergeFromServer(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  window.CrystalsWishlist = {
    addItem: addItem, removeItem: removeItem, getItems: getItems,
    getBoards: getBoards, addBoard: addBoard, removeBoard: removeBoard,
    moveItem: moveItem, hasItem: hasItem, updateHeartStates: updateHeartStates
  };
})();
